import React from 'react'
import { Space } from 'antd'
import FormContent from '../FormContent'
import {
  OrderComplexionFormP2,
  OrderBodyPics,
} from '../../../forms/Clients'

const Step4 = ({ values, errors, handleChange }) => {
  const formsComplexion = [
    { form: [OrderComplexionFormP2], key: 'complexion' },
    { form: [OrderBodyPics], key: '' },
  ]

  return (
    <Space direction="vertical" style={{ width: '100%' }}>
      <FormContent
        values={values}
        errors={errors}
        path=""
        handleChange={handleChange}
        forms={formsComplexion}
      />
    </Space>
  )
}

export default Step4
